import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { DataModelBuilderViewModel } from "../datamodel/dataModelBuilder/dataModelBuilder-viewModel";
import { FormBuilderWindowViewModel } from "./formBuilderWindow-viewModel"
import { ViewModelBuilderViewModel } from "./viewModelBuilder/viewModelBuilder-viewModel";
import { FormBuilderPartViewModel } from "./viewModelBuilder/formBuilderPart/formBuilderPart-viewModel";

export class FormBuilderWindowView extends View<FormBuilderWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-D4257E2C-0710-41B6-85CB-C14E09902879"
    }
    loadHtml(): string {
        let element = require('./formBuilderWindow.html').default;
        let style = require('./formBuilderWindow.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set parts(v: ObservableArray<FormBuilderPartViewModel>) { this._parts = v; } public get parts(): ObservableArray<FormBuilderPartViewModel> { return this._parts;} private _parts: ObservableArray<FormBuilderPartViewModel>;
    public set selectedPart(v: FormBuilderPartViewModel) { this._selectedPart = v; } public get selectedPart(): FormBuilderPartViewModel { return this._selectedPart;} private _selectedPart: FormBuilderPartViewModel;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

}
